import { render } from "./App.vue?vue&type=template&id=a79acf96"
const script = {}

import exportComponent from "D:\\Java_Project\\agriculture\\front\\Agriculture\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__